export { default } from './OutOfAreaErrorContent';
